export default __webpack_public_path__ + "static/media/delete.c0ef2442.svg";